module.exports = __webpack_public_path__ + "fac54184e6deda739c82999ebe0779a5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/badge/ios/RU.svg
// module id = 3133
// module chunks = 0